export default {
  brand: 'USFansLink',
  navSpreadsheet: 'Arkusz',
  navGuides: 'Poradniki',
  navReviews: 'Recenzje',
  navShipping: 'Wysyłka',
  navSafety: 'Bezpieczeństwo',
  navBlog: 'Blog',
  browseLabel: 'Przeglądaj kategorie',
  categoryTitle: 'Kupuj według kategorii',
  categorySubtitle: 'Przejdź od razu do sekcji, której potrzebujesz na głównej stronie.',
  visitMain: 'Odwiedź główną stronę',
  buyNow: 'Kup teraz',
  usfansSpreadsheet: 'Arkusz USFans',
  language: 'Język',
  footerTagline: 'Twój niezależny ośrodek informacji o arkuszach USFans, badaniach produktów, poradach QC i wysyłce.',
  footerResources: 'Zasoby',
  footerLegal: 'Informacje prawne',
  about: 'O nas',
  editorialPolicy: 'Polityka redakcyjna',
  contact: 'Kontakt',
  privacyPolicy: 'Polityka prywatności',
  terms: 'Regulamin',
  disclaimer: 'Zastrzeżenie',
  disclaimerText: 'USFansLink.beauty jest niezależnym źródłem informacji i nie jest powiązany z USFans ani przez niego wspierany, chyba że wyraźnie zaznaczono inaczej.',
  navHome: 'Strona główna',
  navShoppingGuide: 'Poradnik zakupów',
  tagResource: 'Zasób',
  tagReview: 'Recenzja',
  tagLegit: 'Legalność',
  tagShipping: 'Wysyłka',
  tagWarehouse: 'Magazyn',
  tagQc: 'QC',
  tagCoupon: 'Kupon',
  tagSeller: 'Sprzedawca',
  tagSafety: 'Bezpieczeństwo',
  copyright: '© 2026 USFansLink.beauty. Wszelkie prawa zastrzeżone.',
  notFoundTitle: 'Nie znaleziono artykułu',
  notFoundText: 'Artykuł, którego szukasz, nie istnieje lub mógł zostać przeniesiony.',
};